import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getEasyCoptyRightWithCurrentYear } from "../../lib/func/ExportFunction";

import AppServicePolicy from "./AppServicePolicy";

const WebAppPolicy = () => {
    const { t } = useTranslation();

    const copyRightYearInfo = useMemo(() => getEasyCoptyRightWithCurrentYear(), []);

    return (
        <div className="web-main list-area align-items-center justify-content-center p-2">
            <h3>
                {/* 260805: 앱 명칭 변경(Pentalk onScreen -> Pentalk 전용 브라우저 앱)에 따른 번역 키 변경 */}
                <b>{t("Pentalk_전용_앱_개인정보처리방침", { ns: "policy" })}</b>
            </h3>
            <div className="web-policy-box no-modal p-2 my-2 scroll-show">
                <AppServicePolicy />
            </div>
            <div className="footer-template-web" style={{ border: 'none' }}>
                <span>{copyRightYearInfo + t("EasySystems_copyright_1", { ns: "policy" })}</span>
            </div>
        </div>
    );
};

export default WebAppPolicy;